import React from "react";
import "./Alerta.css";
import alertaIcon from "../../assets/alerta.png";

function Alerta() {
  return (
    <section className="alerta-section" id="alerta">
      <div className="alerta-container">
        <img src={alertaIcon} alt="Ícone de alerta" className="alerta-icon" />
        <p className="alerta-text">
          A sua empresa e o seu negócio precisa de um site e deixar a sua marca
          registrada.
        </p>
      </div>
    </section>
  );
}

export default Alerta;
